import axios from '../utils/axios'

// 获取查看业绩 时间查询选项
export function getPerformanceDateOption(params) {
  return axios.post('/user/apiUserAh5Service/getPerformanceDateOptions', params)
}
// 查询业绩数据
export function getStatisticsDate(params) {
  return axios.post('/user/apiUserAh5Service/getStatisticsDate', params)
}

// 查询数据统计报表
export function getReportAgentData(params) {
  return axios.post('/user/apiUserAh5Service/getReportAgentData', params)
}

// 查询数据统计排行榜
export function getReportTableListData(params) {
  return axios.post('/user/apiUserAh5Service/getAgentDataLists', params)
}
